import { render, staticRenderFns } from "./CommandCard.vue?vue&type=template&id=2def7ae0&scoped=true"
import script from "./CommandCard.vue?vue&type=script&lang=js"
export * from "./CommandCard.vue?vue&type=script&lang=js"
import style0 from "./CommandCard.vue?vue&type=style&index=0&id=2def7ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def7ae0",
  null
  
)

export default component.exports